import styled from "styled-components";
import { Banner as HeliosBanner } from "@carvana/helios-layout";
import { border } from "@carvana/helios-styles";

export const BannerContainer = styled.div`
  border-bottom: var(--banner-border) solid ${border.subtle};
`;

export const Banner = styled(HeliosBanner)`
  margin: var(--banner-margin);
`;
